export default [
  {
    path: '/my',
    name: 'MY',
    component: () => import('@/views/my/index'),
    meta: {
      title: '我的'
    }
  },
  {
    path: '/my/infoEdit',
    name: 'INFOEDIT',
    component: () => import('@/views/my/infoEdit')
  },
  {
    path: '/patient/patientList',
    name: 'PATIENTLIST',
    component: () => import('@/views/my/patientList'),
    meta: {
      title: '家庭成员', // 就诊人 档案成员
      keepAlive: true
    }
  },
  {
    path: '/patient/patientEdit',
    name: 'PATIENTEDIT',
    component: () => import('@/views/my/patientEdit'),
    meta: {
      title: '家庭成员'
    }
  },
  {
    path: '/consult/consultList',
    name: 'CONSULTLIST',
    component: () => import('@/views/my/consultList'),
    meta: {
      title: '问诊记录'
    }
  },
  {
    path: '/consult/detail/:id?',
    name: 'CONSULTDETAIL',
    component: () => import('@/views/my/consultDetail'),
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/prescription/list',
    name: 'PRESCRIPTIONLIST',
    component: () => import('@/views/my/prescriptionList'),
    meta: {
      title: '处方'
    }
  },
  {
    path: '/exchange',
    name: 'exchange',
    component: () => import('@/views/my/exchange')
  },
  {
    path: '/deviceManage', // 我的设备
    name: 'DeviceManage',
    component: () => import('@/views/my/deviceManage/index'),
    meta: {
      title: '设备管理'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/my.js